'use client';
import React from 'react';
import UtilityButton from './utilityButton';
import PhoneIcon from '../atoms/icons/phone';
import ArrowIcon from '../atoms/icons/arrow';
import TripadvisorIcon from '../atoms/icons/tripadvisor';
import Email from '../atoms/icons/email';

const ButtonLink = ({
  blok,
  inTextBlock = false,
  parentColor,
  linkWrapsEntireParent = false,
}) => {
  const arrowType =
    blok.link.linktype === 'url' && blok.link.url.indexOf('booking.') === -1
      ? 'external'
      : '';
  let icon = <ArrowIcon type={arrowType} />;

  if (blok.color === 'orange-announcement') {
    icon = <ArrowIcon fill={'#ffffff'} type={arrowType} />;
  }
  /*if (blok.link.anchor && blok.link.anchor.length > 0) {
    icon = <ArrowIcon rotate="rotate-90" type={arrowType} />;
  }*/
  if (blok.link.linktype === 'url' && blok.link.url.startsWith('tel:')) {
    icon = <PhoneIcon fill="#000000" />;
  }
  if (blok.link.linktype === 'email') {
    icon = <Email />;
  }
  if (blok.link.cached_url.indexOf('tripadvisor.com') > -1) {
    icon = <TripadvisorIcon />;
  }

  return (
    !blok.hide_on_site && (
      <UtilityButton
        label={blok.label}
        padding={inTextBlock ? 'mt-4 -ml-2 mb-2 md:-ml-4 md:mb-0' : 'mt-0 mb-4'}
        buttonType={blok.type}
        link={blok.link}
        linkWrapsEntireParent={linkWrapsEntireParent}
        color={blok.color || 'yellow'}
        parentColor={parentColor}
        icon={icon}
        trackingId={blok.tracking_id}
      />
    )
  );
};

export default ButtonLink;
